import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body pb-0 px-0" }
const _hoisted_2 = { class: "d-flex flex-stack px-9" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-dark mb-1 fs-2 fw-boldest" }, "ยอดขายตามหมวดหมู่"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-600 fw-bold mt-2 fs-6" }, "เรียงลำดับยอดขายตามหมวดหมู่สินค้า")
], -1)
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = {
  class: "btn btn-sm btn-icon btn-circle btn-icon btn-active-light",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = { class: "tab-content pt-8" }
const _hoisted_8 = {
  class: "tab-pane fade active show",
  id: "kt_charts_widget_3_tab_pane_1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen023.svg" })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_apexchart, {
            type: "bar",
            height: "320",
            options: _ctx.chartOptions,
            series: _ctx.series1
          }, null, 8, ["options", "series"])
        ])
      ])
    ])
  ], 2))
}